import React from 'react'
import styled from 'styled-components'
import Text from '../../Text'
import { SCREEN_SIZE } from '../../../lib/Media'
import { setUserType } from '../../../utils/userType'
import { Router } from '../../../routes'
import Popup from '../../Popup'

const PopupContainer = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(51, 51, 51, 0.24);
  border-radius: 4px;
  padding: 1rem;
  margin: 0 1rem;
  ${SCREEN_SIZE.From.Tablet} {
    width: 20.5rem;
    height: auto;
  }
`

const Header = styled.div`
  position: relative;
`

const PopupContent = styled.div`
  margin-bottom: 1.5rem;
`
const ButtonWrp = styled.div`
  display: flex;
  justify-content: space-evenly;
`

const Button = styled.button`
  cursor: pointer;
  background: #f2f2f2;
  border-radius: 4px;
  padding: 8px 16px;
  outline: none;
  border: none;
`

const ButtonBlue = styled(Button)`
  padding: 8px 16px;
  background: #1454b8;
  border-radius: 4px;
`

const HeaderText = styled(Text)`
  line-height: 1.75rem;
`
const MainText = styled(Text)`
  line-height: 1.5rem;
`
const redirectToHomepage = () => {
  Router.pushRoute(`/`)
}

const SwitchToB2CProfile = () => {
  setUserType('B2C', true, true, null)
}

const ProfileSwitchPopup = () => {
  return (
    <Popup forceAcknowledge={true} data-testid="interest-registration-popup">
      <PopupContainer>
        <Header>
          <HeaderText size="xl" weight="bold" color="#333333">
            Digital Club is not available on FairPrice for Business
          </HeaderText>
        </Header>
        <PopupContent>
          <MainText size="large" color="#333333">
            You can join Digital Club on FairPrice for Personal to enjoy the
            benefits.
          </MainText>
        </PopupContent>
        <ButtonWrp>
          <Button
            onClick={redirectToHomepage}
            data-testid="switch-back-to-home"
          >
            <Text size="medium" weight="bold" color="#333333">
              Back to home
            </Text>
          </Button>
          <ButtonBlue
            onClick={SwitchToB2CProfile}
            data-testid="switch-to-personal-b2b"
          >
            <Text size="medium" color="#ffffff" weight="bold" align="center">
              Switch to Personal
            </Text>
          </ButtonBlue>
        </ButtonWrp>
      </PopupContainer>
    </Popup>
  )
}

export default ProfileSwitchPopup
